import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import Spinner from '../../../components/Spinner';
import storeActions from '../../../redux/futures/store/actions';
import _ from 'lodash';
import Input from '../../../components/Input';
import CustomDatePicker from "../../../components/DatePicker/CustomDatePicker";

class ItemAddon extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);
        const date = new Date();
        this.state = {
            is_base_pkg: false,
            app_code: '',
            pkg_name: '',
            resource_type: '',
            limit_value: '',
            exp_date: date,
            resourceLimitConfigs: [],
            filteredResourceTypes: [],
            selectedConfig: null
        };
        this.inputsRef = new Set();
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        // console.log('nextProps:', nextProps);
        if (nextProps.resourceLimitConfigs) {
            // console.log('resourceLimitConfigs:', nextProps.resourceLimitConfigs);
            this.setState({
                resourceLimitConfigs: nextProps.resourceLimitConfigs
            });
        }
    }

    handleAppCodeChange = (e) => {
        const app_code = e.target.value;
        const filteredTypes = this.state.resourceLimitConfigs.filter(
            config => config.app_code === app_code
        );
        this.setState({
            app_code,
            resource_type: '',
            limit_value: '',
            filteredResourceTypes: filteredTypes
        });
    }

    handleResourceTypeChange = (e) => {
        const resource_type = e.target.value;
        const selectedConfig = this.state.filteredResourceTypes.find(
            config => config.resource_type === resource_type
        );
        this.setState({
            resource_type,
            limit_value: '',
            selectedConfig,
            is_base_pkg: selectedConfig.is_base_pkg
        });
    }

    handleLimitValueChange = (e) => {
        const value = parseInt(e.target.value);
        const { selectedConfig } = this.state;
        this.setState({ limit_value: value });
    }

    handleExpriredateChange = (date) => {
        this.setState({ exp_date: date });
    }

    handlePkgNameChange = (e) => {
        this.setState({ pkg_name: e.target.value });
    }

    handleSubmit = () => {
        const { app_code, resource_type, limit_value, exp_date, selectedConfig, is_base_pkg, pkg_name } = this.state;
        if (!app_code || !resource_type || !limit_value) {
            window.LadiUI.toastr('error', '', 'Vui lòng nhập đầy đủ thông tin');
            return;
        }

        // Only check exp_date if limit_type is not LIFE_TIME or ONE_TIME
        if (selectedConfig && !['LIFE_TIME', 'ONE_TIME'].includes(selectedConfig.limit_type) && !exp_date) {
            window.LadiUI.toastr('error', '', 'Vui lòng chọn ngày hết hạn');
            return;
        }

        // if (selectedConfig && limit_value % selectedConfig.limit_value !== 0) {
        //     window.LadiUI.toastr('error', '', `Giá trị giới hạn phải là bội số của ${selectedConfig.limit_value}`);
        //     return;
        // }

        const data = {
            ladi_uid: this.props.currentUser._id,
            app_code,
            resource_type,
            limit_value: parseInt(limit_value),
            pkg_name: is_base_pkg ? pkg_name : null,
            exp_date: selectedConfig && ['LIFE_TIME', 'ONE_TIME'].includes(selectedConfig.limit_type) ? null : exp_date
        };
        if (is_base_pkg) {
            data.limit_value = 1;
        }

        this.props.addResourceLimit(data);
    }

    render() {
        const { app_code, resource_type, limit_value, exp_date, resourceLimitConfigs, filteredResourceTypes, selectedConfig, is_base_pkg, pkg_name } = this.state;
        const uniqueAppCodes = _.uniqBy(resourceLimitConfigs, 'app_code');
        const showExpDate = selectedConfig && !['LIFE_TIME', 'ONE_TIME'].includes(selectedConfig.limit_type);

        return (
            <div id="modal-item-addon" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-item-addon" style={{ zIndex: '22' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-item-addon">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-item-addon" />
                        </button>
                        <h3>Add New Resource Limit</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        <div className="ladiui-form">
                            {selectedConfig && (
                                <div className="ladiui form-group">
                                    <div className="ladiui-card">
                                        <div className="ladiui-card-body">
                                            <h4>Chi tiết cấu hình addon</h4>
                                            <div className="ladiui-row" style={{ height: '50px' }}>
                                                <div className="col-50">
                                                    <strong>Ứng dụng: </strong>
                                                    {
                                                        selectedConfig.app_code || '--'
                                                    }
                                                </div>
                                                <div className="col-50">
                                                    <strong>Loại tài nguyên: </strong>
                                                    {
                                                        selectedConfig.resource_type || '--'
                                                    }
                                                </div>
                                            </div>
                                            <div className="ladiui-row" style={{ height: '50px' }}>
                                                <div className="col-50">
                                                    <strong>Giá trị giới hạn nhỏ nhất: </strong>
                                                    {
                                                        selectedConfig.limit_value || '--'
                                                    }
                                                </div>
                                                <div className="col-50">
                                                    <strong>Giá: </strong>
                                                    {
                                                        selectedConfig.price || '--'
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Ứng dụng</label>
                                <div className="ladiui-select-options" style={{ zIndex: 10 }}>
                                    <span className="ladiui-select-init">{app_code || 'Chọn ứng dụng'}</span>
                                    <input type="hidden" name="select" defaultValue />
                                    <ul>
                                        <li className="select-item" onClick={() => this.handleAppCodeChange({ target: { value: '' } })}>
                                            <a href="#" data-value="">Chọn ứng dụng</a>
                                        </li>
                                        {uniqueAppCodes.map((config, index) => (
                                            <li key={index} className="select-item" onClick={() => this.handleAppCodeChange({ target: { value: config.app_code } })}>
                                                <a href="#" data-value={config.app_code}>{config.app_code}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Loại tài nguyên</label>
                                <div className="ladiui-select-options">
                                    <span className="ladiui-select-init">{resource_type || 'Chọn loại tài nguyên'}</span>
                                    <input type="hidden" name="select" defaultValue />
                                    <ul>
                                        <li className="select-item" onClick={() => this.handleResourceTypeChange({ target: { value: '' } })}>
                                            <a href="#" data-value="">Chọn loại tài nguyên</a>
                                        </li>
                                        {filteredResourceTypes.map((config, index) => (
                                            <li key={index} className="select-item" onClick={() => this.handleResourceTypeChange({ target: { value: config.resource_type } })}>
                                                <a href="#" data-value={config.resource_type}>{config.resource_type}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="ladiui form-group">
                                <label className="ladiui-label">Giá trị giới hạn</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name="limit_value"
                                    validationName="Giá trị giới hạn"
                                    placeholder="Giá trị giới hạn"
                                    value={limit_value}
                                    type='number'
                                    onChange={this.handleLimitValueChange}
                                    disabled={!resource_type || is_base_pkg}
                                    validations={{ isRequired: true, min: 0 }}
                                />
                            </div>
                            {
                                is_base_pkg &&
                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Package Name</label>
                                    <Input
                                        ref={(ref) => this.inputsRef.add(ref)}
                                        name="pkg_name"
                                        validationName="Tên gói"
                                        placeholder="Tên gói"
                                        value={pkg_name}
                                        onChange={this.handlePkgNameChange}
                                        validations={{ isRequired: true }}
                                    />
                                </div>
                            }
                            {showExpDate && (
                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Ngày hết hạn</label>
                                    <CustomDatePicker
                                        customClass="ladiui input date"
                                        selected={exp_date}
                                        onChange={this.handleExpriredateChange}
                                    />
                                </div>
                            )}

                            <div className="ladiui form-group text-right">
                                <button
                                    className="ladiui button primary"
                                    onClick={this.handleSubmit}
                                >
                                    Thêm giới hạn tài nguyên
                                </button>
                            </div>
                        </div>
                        {this.props.loading && <Spinner />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    resourceLimitConfigs: state.store.resourceLimitConfigs,
    loading: state.store.loading
});

const mapDispatchToProps = (dispatch) => ({

    addResourceLimit: (data) => dispatch(storeActions.addResourceLimit(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemAddon); 